import { ShareButton } from '@components/ShareButton'
import { ShareEmailForm } from '@forms/ShareEmailForm'
import { ArticleTitleImage } from '@ui/article/ArticleTitleImage'

import { Wrapper } from './styles'
import { Switcher } from './switcher'
import { AcrticleGeneratorProps } from './types'

export function ArticleGenerator({ config }: AcrticleGeneratorProps) {
  const { article, headerProps, emailFormProps, pageUniqId } = config

  return (
    <>
      <ArticleTitleImage {...headerProps} />
      <Wrapper>
        {article.map((block, index) => (
          <Switcher key={pageUniqId + index} block={block} />
        ))}
        <ShareButton />
      </Wrapper>
      <ShareEmailForm {...emailFormProps} />
    </>
  )
}
